import React, { useEffect, useState } from "react";

import { Form, Formik } from "formik";
import {
  SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Flex,
  Box,
  Text,
} from "@chakra-ui/react";
import Swal from "sweetalert2";
import * as Yup from "yup";

import { useAppContext } from "../../../../../../Context/MessageContextProvider";
import { CustomButton } from "../../../../../components/CustomButton";
import PromotoriaService from "../../../../../../main/services/PromotoriaService";
import RadioGroupTable from "../../../../../components/RadioGroupTable";
import FiltersRadioGroupTable from "../../../../../components/FiltersRadioGroupTable";
import LoadingSpinner from "../../../../../components/LoadingSpinner";
import { hasFormChanged } from "../../../../../utils/hasFormChanged";
import CriancaService from "../../../../../../main/services/CriancaService";
import { situacaoJuridica } from "../../../../../../helpers/Funcionalidades";
import { CustomTextArea } from "../../../../../components/CustomTextArea";
import SemRegistros from "../../../../../components/SemRegistros";

const EditarPromotoriaModal = ({
  isOpen,
  onOpen,
  onClose,
  dataVoluntaria,
  columnsPromotoriaModal,
  idCrianca,
  fetchAtribuicao,
  roleKeycloack,
}) => {
  const schema = Yup.object().shape({
    idOrgao: Yup.string().test(
      "promotoria-diferente",
      "Selecione outra promotoria",
      function (value) {
        if (
          dataVoluntaria[0]?.tipoAtribuicaoPromotoria === "A" &&
          value === dataVoluntaria[0]?.id.toString()
        ) {
          return false;
        }
        return true;
      }
    ),
    justificativaPromotoria: Yup.string()
      .when("perfil", {
        is: (perfil) => perfil === true,
        then: (schema) => schema.required("Este campo é obrigatório!"),
      })
      .trim(),
  });

  const {
    cadastrarProcessosProcedimentos,
    setCadastrarProcessosProcedimentos,
  } = useAppContext();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [initialValues, setInitialValues] = useState({
    idOrgao: "",
    justificativaPromotoria: "",
    concorrente: false,
    perfil: false,
  });
  const [isTextareaFocused, setIsTextareaFocused] = useState(false);

  useEffect(() => {
    if (isOpen === true) {
      PromotoriaService.getPromotoriasLogado()
        .then((res) => {
          setLoading(false);
          if (
            roleKeycloack.includes(situacaoJuridica.promotoriaEditarConcorrente)
          ) {
            const resDataFilter = res.data
              .filter((item) => item.concorrente === true)
              .map((item) => item);

            setData(resDataFilter);
          } else {
            setData(res.data);
          }
        })
        .catch((error) => console.log(error));
    }
  }, [isOpen, roleKeycloack]);

  const editarPromotoriaJuridica = async (id, valuesToSend) => {
    try {
      await CriancaService.editarPromotoriaJuridica(id, valuesToSend);
      Swal.fire({
        title: "Sucesso!",
        text: "Registro atualizado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {});
      onClose();
      fetchAtribuicao();
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Atenção!",
        text: error.response.data.message ? error.response.data.message : "",
        icon: "warning",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#169499",
      });
    }
  };

  const backAlert = () => {
    if (cadastrarProcessosProcedimentos) {
      Swal.fire({
        title: "Tem certeza que deseja cancelar?",
        text: "As informações serão perdidas.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#169499",
        cancelButtonColor: "#169499",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((result) => {
        if (result.isConfirmed) {
          onClose();
          setCadastrarProcessosProcedimentos(false);
        }
      });
    } else {
      onClose();
    }
  };

  const handleSubmit = (values, actions) => {
    setLoadingSubmit(true);
    const { justificativaPromotoria, idOrgao, concorrente } = values;

    const valuesToSend = {
      idOrgao: idOrgao ? Number(idOrgao) : null,
      justificativa: justificativaPromotoria
        ? justificativaPromotoria?.trim()
        : "",
      concorrente: concorrente,
    };
    editarPromotoriaJuridica(Number(idCrianca), valuesToSend);

    setLoadingSubmit(false);
  };

  useEffect(() => {
    if (dataVoluntaria) {
      setInitialValues({
        idOrgao: dataVoluntaria[0]?.id.toString(),
        justificativaPromotoria: dataVoluntaria[0]?.justificativa
          ? dataVoluntaria[0]?.justificativa.toString()
          : "",
        concorrente: dataVoluntaria[0]?.promotoriaConcorrente
          ? dataVoluntaria[0]?.promotoriaConcorrente
          : false,
        perfil: roleKeycloack.includes(situacaoJuridica.promotoriaEditar),
      });
    }
  }, [dataVoluntaria, roleKeycloack]);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        size="6xl"
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent
          p={{ base: "15px", md: "25px" }}
          w={{ base: "100%", lg: "70%" }}
          bgColor="#FFF"
        >
          <ModalHeader
            p="0px"
            fontWeight={700}
            fontSize="14px"
            lineHeight="19.6px"
            color="#169499"
          >
            EDITAR PROMOTORIA DE JUSTIÇA
          </ModalHeader>
          <ModalBody p="0px" mt="25px">
            <Formik
              validationSchema={schema}
              initialValues={initialValues}
              onSubmit={handleSubmit}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(props) => (
                <>
                  <FiltersRadioGroupTable
                    setData={setData}
                    entidade="promotoria"
                    atribuicao={true}
                    searchBlock={
                      initialValues.concorrente &&
                      !roleKeycloack.includes(situacaoJuridica.promotoriaEditar)
                    }
                    setLoading={setLoading}
                    situacao={true}
                  />
                  <Form>
                    {setCadastrarProcessosProcedimentos(
                      hasFormChanged(initialValues, props.values)
                    )}
                    {!loading ? (
                      <>
                        {!!data && data?.length > 0 ? (
                          <RadioGroupTable
                            data={data}
                            columns={columnsPromotoriaModal}
                            edit={true}
                            promotoria={true}
                          />
                        ) : (
                          <Box mt="4">
                            <SemRegistros buttonVisible={true} half />
                          </Box>
                        )}
                      </>
                    ) : (
                      <Box mt="4">
                        <LoadingSpinner loading={loading} />
                      </Box>
                    )}

                    {dataVoluntaria[0]?.tipoAtribuicaoPromotoria === "A" &&
                      props.values.idOrgao ===
                        dataVoluntaria[0]?.id.toString() &&
                      props.errors.idOrgao && (
                        <Text color="#e53e3e" fontSize="14px" mb={4}>
                          {props.errors.idOrgao ? props.errors.idOrgao : ""}
                        </Text>
                      )}

                    {roleKeycloack.includes(
                      situacaoJuridica.promotoriaEditar
                    ) && (
                      <CustomTextArea
                        fieldName={"justificativaPromotoria"}
                        label={"Justificativa*"}
                        placeholder={"Informe a Justificativa"}
                        setIsTextareaFocused={setIsTextareaFocused}
                        maxLength={255}
                        isTextareaFocused={isTextareaFocused}
                      />
                    )}
                    <Flex justifyContent="end">
                      <SimpleGrid
                        mt="25px"
                        columns={2}
                        spacing="15px"
                        w={{ base: "100%", lg: "40%" }}
                      >
                        <CustomButton onClick={backAlert} label="Cancelar" />
                        <CustomButton
                          type="submit"
                          translate="no"
                          isDisabled={loading}
                          isLoading={props.isSubmitting || loadingSubmit}
                          label="Salvar"
                        />
                      </SimpleGrid>
                    </Flex>
                  </Form>
                </>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default EditarPromotoriaModal;
